import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional } from '@servicetitan/react-ioc';
import { PortalPaymentMethods } from './portal-saved-payment-methods-api';

@injectable()
export class SavedPaymentMethodsApi {
    private api: PortalPaymentMethods;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.api = new PortalPaymentMethods(
            createMainAppMicroserviceInstance(
                '/v1/customerportal2/savedpaymentmethods',
                '/api/cp/savedpaymentmethods'
            ),
            baseUrl
        );
    }

    async getConfiguration() {
        const response = await this.api.getConfiguration();
        return response.data;
    }
}
